import { BottomNavigation, BottomNavigationAction } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

type BottomNavProps = {
    onClickPrev: (event: React.MouseEvent) => void;
    onClickNext: (event: React.MouseEvent) => void;
}

export const BottomNav: React.FC<BottomNavProps> = ({onClickNext, onClickPrev}) => {

    return (
        <BottomNavigation sx={{ position: 'fixed', bottom: 0, width: 1.0 }} showLabels>
            <BottomNavigationAction onClick={onClickPrev} label="Zurück" icon={<ArrowBackIcon />} />
            <BottomNavigationAction  label="Hilfe" icon={<HelpOutlineIcon />} />
            <BottomNavigationAction onClick={onClickNext} label="Weiter" icon={<ArrowForwardIcon />} />
        </BottomNavigation>
    )
}